export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '联系人账号分类',
                'value': 'accountType',
                'type': 'select',
                'unfold': true,
                'options': [
                    {
                        label: '供应商',
                        value: '1'
                    },
                    {
                        label: '司机',
                        value: '2'
                    },
                    {
                        label: '银行',
                        value: '3'
                    }
                ],
                'span': 3,
                'multiple': false
            },
            {
                'name': '是否分配账号',
                'value': 'distributionCode',
                'type': 'select',
                'unfold': true,
                'span': 3,
                'options': [
                    {
                        label: '是',
                        value: '0'
                    },
                    {
                        label: '否',
                        value: '1'
                    }
                ],
                'multiple': false
            },
            {
                'name': '联系人账号类型',
                'value': 'userType',
                'type': 'select',
                'unfold': true,
                'span': 3,
                'options': [
                    {
                        label: '主账号',
                        value: '1'
                    },
                    {
                        label: '子账号',
                        value: '2'
                    }

                ],
                'multiple': false
            },
            {
                'name': '联系人账号',
                'value': 'userCode',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '联系人状态',
                'value': 'contactsStatus',
                'type': 'select',
                'unfold': true,
                'span': 3,
                'options': [
                    {
                        label: '启用',
                        value: '0'
                    },
                    {
                        label: '停用',
                        value: '1'
                    }

                ],
                'multiple': false
            }],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
        {
            'switchType': true,
            'tableCut': false,
            'clickState': true,
            'selectBtn': true,
            'height': 400,
            'statesY': '启用',
            'statesN': '停用',
            'columns': [
                {
                    'label': '供应商编号',
                    'prop': 'supplierCode',
                    'width': '150px'
                },
                {
                    'label': '供应商名称',
                    'prop': 'supplierNameCn',
                    'width': '200px'
                },
                {
                    'label': '供应商状态',
                    'prop': 'supplierStatus',
                    'width': '200px'
                },
                {
                    'label': '联系人状态',
                    'prop': 'contactsStatus',
                    'width': '200px'
                },
                {
                    'label': '是否在途联系人',
                    'prop': 'onWayContactFlag_',
                    'width': '120px',
                    'lgtpptVisible': true,
                },
                {
                    'label': '联系人姓名',
                    'prop': 'contacts',
                    'width': '200px'
                },
                {
                    'label': '手机号',
                    'prop': 'contactsMobile',
                    'width': '200px'
                },
                {
                    'label': '身份证号',
                    'prop': 'idCard',
                    'width': '200px'
                },
                {
                    'label': '对公邮箱',
                    'prop': 'contactsEmail',
                    'width': '200px'
                },
                {
                    'label': '职务',
                    'prop': 'contactsPost',
                    'width': '200px'
                },
                {
                    'label': '办公地址',
                    'prop': 'contactsAddress',
                    'width': '200px'
                },
                {
                    'label': '联系人账号',
                    'prop': 'userCode',
                    'width': '200px'
                },
                {
                    'label': '联系人账号分类',
                    'prop': 'accountType',
                    'width': '200px'
                },
                {
                    'label': '联系人账号类型',
                    'prop': 'userType',
                    'width': '200px'
                },
                {
                    'label': '联系人账号角色',
                    'prop': 'roleNameJson',
                    'width': '200px'
                },
                {
                    'label': '联系人账号状态',
                    'prop': 'accountStatusText',
                    'width': '130px',
                },
                {
                    'label': '创建时间',
                    'prop': 'createTime',
                    'width': '200px'
                },
                {
                    'label': '创建人',
                    'prop': 'createUserName',
                    'width': '200px'
                },
                {
                    'label': '修改人',
                    'prop': 'updateUserName',
                    'width': '200px'
                }],
            'action':
                [{
                    'type': 'text',
                    'label': '权限分配',
                    'size': 'mini',
                    'event': 'permission',
                    'ifHas': '08000204'
                },
                {
                    'type': 'text',
                    'label': '生成账号',
                    'size': 'mini',
                    'event': 'create-account',
                    'ifHas': '08000205'
                },
                {
                    'type': 'text',
                    'label': '重置密码',
                    'size': 'mini',
                    'event': 'reset-password',
                    'ifHas': '08000206'
                },
                {
                    'type': 'text',
                    'label': '绑定租户',
                    'size': 'mini',
                    'event': 'bind-tenant',
                    'ifHas': '08000207'
                }],
            'leftOperation': true,
            'leftWidth': 250
        },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
